define('components/NativeAdNetwork',[
    "logging",
    "admiral",
    "delayedtasks"
], function (logging, admiral, delayedtasks) {
    var _ModuleName = "NativeAdNetwork";

    function NativeAdNetwork(scope, config) {
        "use strict";
        
        if(admiral.isEnabled()) { 
            admiral.checkUserSubscribed(function() {
                ;
            }, function() {
                init(scope, config);
            }, function() {
                ;
            })
        } else {
            init(scope, config);

            ;
        }
    }

    var init = function(scope, config) {
        delayedtasks.registerTask(function() {
            console.log("loading taboola script");

            window._taboola = window._taboola || [];
            _taboola.push({article:'auto'});
            !function (e, f, u, i) {
                if (!document.getElementById(i)){
                e.async = 1;
                e.src = u;
                e.id = i;
                f.parentNode.insertBefore(e, f);
                }
            }(document.createElement('script'),
            document.getElementsByTagName('script')[0],
            '//cdn.taboola.com/libtrc/bnmedia-patheos1/loader.js',
            'tb_loader_script');
            if(window.performance && typeof window.performance.mark == 'function')
                {window.performance.mark('tbl_ic');}

            ;
            ;

            window._taboola = window._taboola || [];
            _taboola.push({
                mode: 'thumbnails-a',
                container: config.container_id, //'taboola-below-article-thumbnails'
                placement: config.widget_id,
                target_type: 'mix'
            });
        });
        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new NativeAdNetwork(args.scope, args.Config);
        }
    }
});
